import { ROUTE_PATH_YOUR_DECKS } from "page/deck-manager/deck/decks/your-saved-decks-config";

export const ROUTE_PATH_DECKS_EDIT_MODE = (dbid) => `${ROUTE_PATH_YOUR_DECKS}/${dbid}`;
